import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import { mockOrganisationResponse } from '@percent/admin-dashboard/fixtures/api/mockOrganisationResponse'
import { mockOrganisationDefaultLocale } from '@percent/admin-dashboard/fixtures/api/organisation/mockOrganisationDefaultLocale'
import { mockSuccessResponse } from '@percent/admin-dashboard/fixtures/api/mockSuccessResponse'
import { mockAvailableLocales } from '@percent/admin-dashboard/fixtures/api/organisation/mockAvailableLocales'
import { mockOrganisationFiles } from '@percent/admin-dashboard/fixtures/api/organisation/mockOrganisationFiles'

export const organizationsHandlers = [
  rest.get(`${config.urls.api}v1/admin/foundations`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse([])))
  }),
  rest.get(`${config.urls.api}v1/currencies`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse([])))
  }),
  rest.get(`${config.urls.api}v1/admin/experience/available-locales`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse(mockAvailableLocales)))
  }),
  rest.put(`${config.urls.api}v1/admin/experience/organisations/:id/default-locale`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse(mockOrganisationDefaultLocale)))
  }),
  rest.get(`${config.urls.api}v1/admin/experience/organisations/:id/default-locale`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse(mockOrganisationDefaultLocale)))
  }),
  rest.get(`${config.urls.api}v1/admin/experience/organisations/:id/images`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse(mockOrganisationFiles)))
  }),
  rest.post(`${config.urls.api}v1/admin/experience/organisations/:id/images`, async (_, res, ctx) => {
    return res(ctx.status(200))
  }),
  rest.patch(`${config.urls.api}v1/admin/organisations/:id`, (_, res, ctx) => {
    return res(ctx.status(200))
  }),
  rest.post(`${config.urls.api}v1/admin/organisations/:id/unclaim`, (_, res, ctx) => {
    return res(ctx.status(204), ctx.json({}))
  }),
  rest.get(`${config.urls.api}v1/admin/organisations/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockOrganisationResponse.data))
  })
]
